export const locale = {
  'ORDERS': {
    'ONMAP': {
      'TITLE' : 'Orders on map',
    },
  },
};
